export default __webpack_public_path__ + "static/media/3233 utensils side.b3106557.png";